export default function filterTableData(data, searchTerm, key) {
  if (!searchTerm) return data;

  return data.filter((item) => {
    const value = getNestedValue(item, key);
    return value?.toLowerCase().includes(searchTerm.toLowerCase());
  });
}

function getNestedValue(obj, key) {
  return key.split('.').reduce((o, k) => (o && o[k] ? o[k] : ''), obj);
}

